export const WEBSITE_CARDS_RESET_STATE = 'WEBSITE_CARDS_RESET_STATE';
export const WEBSITE_CARDS_CURRENT_ITEM = 'WEBSITE_CARDS_CURRENT_ITEM';
 
export const WEBSITE_CARDS_REQUEST_LOADING = 'WEBSITE_CARDS_REQUEST_LOADING';
export const WEBSITE_CARDS_REQUEST_SUCCESS = 'WEBSITE_CARDS_REQUEST_SUCCESS';
export const WEBSITE_CARDS_REQUEST_FAILED = 'WEBSITE_CARDS_REQUEST_FAILED';
 
export const WEBSITE_CARDS_CURRENT_ACTION = 'WEBSITE_CARDS_CURRENT_ACTION';
export const WEBSITE_CARDS_RESET_ACTION = 'WEBSITE_CARDS_RESET_ACTION';